import React from "react";
import { motion } from "framer-motion";
import nepaligranny from "../assets/hero-granny-wide.png";
import cgmSystemImg from "../assets/images/cgm-system.png";
import HeroParticles from "./HeroParticles";

export default function Hero({ onHotProduct }) {
  return (
    <section className="hero">
      <div className="hero-shell">
        <HeroParticles />
        <motion.div
          className="hero-slogan-row"
          initial={{ opacity: 0, y: 14 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.8 }}
        >
          <div className="hero-slogan-eyebrow">
            <motion.span
              className="eyebrow-line"
              animate={{ scaleX: [0.85, 1, 0.85], opacity: [0.5, 1, 0.5] }}
              transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
            />
            <motion.p
              className="hero-slogan-text"
              animate={{ opacity: [0.92, 1, 0.92] }}
              transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
            >
              स्वास्थ्य सामग्री, सजिलै घरसम्म
            </motion.p>
            <motion.span
              className="eyebrow-line"
              animate={{ scaleX: [0.85, 1, 0.85], opacity: [0.5, 1, 0.5] }}
              transition={{ duration: 3, repeat: Infinity, ease: "easeInOut", delay: 0.4 }}
            />
          </div>
        </motion.div>

        <div className="hero-layout">
          <motion.aside
            className="hero-panel"
            initial={{ opacity: 0, x: -16 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.3, duration: 0.75 }}
          >
            <motion.div
              className="hero-trust-badge"
              animate={{ y: [0, -3, 0] }}
              transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
            >
              <span className="hero-trust-label">Free expert consultation</span>
              <span className="hero-trust-text">Doctor &amp; biomedical engineer guidance</span>
            </motion.div>

            <p className="hero-panel-line">
              Trusted equipment. Expert installation. Delivered to your door.
            </p>

            <div className="hero-cta-group">
              <button
                type="button"
                className="hero-hot-product"
                onClick={onHotProduct}
                aria-label="View hot product"
              >
                <span className="hero-hot-product-copy">
                  <span className="hero-hot-product-badge">Hot Product</span>
                  <span className="hero-hot-product-rule" aria-hidden="true" />
                </span>
                <span className="hero-hot-product-media">
                  <img src={cgmSystemImg} alt="" className="hero-hot-product-img" />
                </span>
              </button>
            </div>

            <p className="hero-panel-note">Premium biomedical supply · Nepal</p>
          </motion.aside>

          <motion.div
            className="hero-scene"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.15, duration: 0.85 }}
          >
            <div className="hero-image-wrap">
              <img
                src={nepaligranny}
                alt="Nepali grandmother in a premium electric wheelchair at home"
                className="hero-image"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
